module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--circle",
    style: (_vm.styles),
    attrs: {
      "viewBox": "0 0 66 66",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "fill": "none",
      "stroke-width": "6",
      "stroke-linecap": "round",
      "cx": "33",
      "cy": "33",
      "r": "30"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d65da49c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Circle.vue
// module id = 160
// module chunks = 0